import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationManager } from '@managers/notification.manager';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { take, takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/components/base.component';
import { DocViewerParamReader } from '@utilities/doc-viewer-param-reader';
import { TabStates } from '@utilities/tab-states';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { documentViewActions } from '@store/doc-viewer/document-view/document-view.actions';

@Component({
    selector: 'lex-doc-compare-panel',
    templateUrl: './doc-compare-panel.component.html',
    styleUrls: ['./doc-compare-panel.component.scss'],
    standalone: false
})
export class DocComparePanelComponent extends BaseComponent {

	private diffDocId: string;

	constructor(
		public docViewerStore: DocViewerStore,
		private tabStates: TabStates,
		private notificationManager: NotificationManager,
		private paramReader: DocViewerParamReader,
		private router: Router,
		private route: ActivatedRoute,
		private location: Location,
		private store: Store
	) {
		super();
		this.docViewerStore.simpleState$.pipe(
			takeUntil(this.destroy$)
		).subscribe((state) => {
			this.diffDocId = state.compareDocumentId;
			if (state.compareDocumentId) {
				localStorage.setItem('compareDocumentId', this.diffDocId);
			} else {
				localStorage.removeItem('compareDocumentId');
			}
		});
	}

	public setCompareDoc(): void {
		this.docViewerStore.currentDocument$.pipe(
			take(1)
		).subscribe((currentDocument) => {
			this.store.dispatch(documentViewActions.viewUpdated({selectedView:'text-compare'}));
			this.docViewerStore.updateState((currentState) => {
				currentState.compareDocumentId = currentDocument.docId;
				this.modifyDiffDocIdUrlParam(currentDocument.docId, currentDocument.docId);
				return currentState;
			}).subscribe(() => {
				this.notificationManager.displaySnackBarMessage({
					message: 'Compare Doc Set.'
				});
			});
		});
	}

	public clearCompareDoc(): void {
		this.docViewerStore.updateState((currentState) => {
			currentState.compareDocumentId = null;
			localStorage.removeItem('compareDocumentId');
			if (currentState.hasPdfRendering)
				this.store.dispatch(documentViewActions.viewUpdated({ selectedView: 'pdf' }));
			else
				this.store.dispatch(documentViewActions.viewUpdated({ selectedView: 'html' }));

			return currentState;
		}).subscribe(() => {
			this.notificationManager.displaySnackBarMessage({
				message: 'Compare Doc Cleared.'
			});
		});

		this.docViewerStore.currentDocument$.pipe(
			take(1)
		).subscribe((currentDocument) => {
			this.modifyDiffDocIdUrlParam(currentDocument.docId, "");
		});
	}

	private modifyDiffDocIdUrlParam(currentDocId: string, diffDocId: string): void {
		this.paramReader.read(this.route.snapshot.queryParams);

		if (this.paramReader.diffDocId) {
			this.paramReader.diffDocId = diffDocId;
			const newParams = this.paramReader.changeDocTo(currentDocId)
			const url = this.router.createUrlTree([], {
				relativeTo: this.route,
				queryParams: newParams
			}).toString();
			this.location.replaceState(url);
		}
	}
}
